import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackPixelEvent } from '../../utils/metaPixel';
interface CtaButtonProps {
  children: React.ReactNode;
  href?: string;
  tone?: 'moss' | 'orange';
  size?: 'md' | 'lg' | 'xl';
  showIcon?: boolean;
  className?: string;
}
export function CtaButton({
  children,
  href = '#offer',
  tone = 'orange',
  size = 'lg',
  showIcon = true,
  className = ''
}: CtaButtonProps) {
  const toneClasses = tone === 'moss' ? 'bg-moss text-white shadow-block hover:bg-[#175a39]' : 'bg-orange text-white shadow-block-orange hover:bg-orange-dark';
  const sizeClasses = size === 'xl' ? 'px-10 py-5 text-base sm:px-16 sm:py-6 sm:text-xl' : size === 'lg' ? 'px-8 py-4 text-sm sm:px-10 sm:py-5 sm:text-base' : 'px-6 py-3 text-xs sm:text-sm';
  return <a href={href} onClick={() => trackPixelEvent('InitiateCheckout')} className={`group inline-flex items-center justify-center gap-2.5 rounded-2xl font-black uppercase tracking-[0.04em] transition-[transform,background-color] duration-150 ease-snap hover:-translate-y-0.5 active:translate-y-1 active:shadow-none ${toneClasses} ${sizeClasses} ${className}`} data-id="element-255" data-mp="136tqy8vnvzfe">
      {children}
      {showIcon && <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-snap group-hover:translate-x-1" strokeWidth={3} aria-hidden="true" data-id="element-256" data-mp="2qhj5ct149h7e" />}
    </a>;
}